<template>
  <div class="rm-empty-state">
    <div class="rm-empty-state__icon">
      <i :class="icon"></i>
    </div>
    <div class="rm-empty-state__title">{{ title }}</div>
    <div v-if="description" class="rm-empty-state__desc">{{ description }}</div>
    <div v-if="$slots.default" class="rm-empty-state__action">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
  props: {
    title: { type: String, default: '暂无数据' },
    description: { type: String, default: '' },
    icon: { type: String, default: 'el-icon-document' }
  }
}
</script>

<style lang="scss" scoped>
.rm-empty-state {
  padding: 48px 24px;
  text-align: center;
}

.rm-empty-state__icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 16px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--rm-gray-100);
  color: var(--rm-text-tertiary);
  font-size: 28px;
}

.rm-empty-state__title {
  font-size: 14px;
  font-weight: 500;
  color: var(--rm-text-secondary);
}

.rm-empty-state__desc {
  margin-top: 8px;
  font-size: 13px;
  color: var(--rm-text-tertiary);
}

.rm-empty-state__action {
  margin-top: 16px;
}
</style>
